import React from 'react';

const BoldIcon = props => (
  <svg viewBox="0 0 12 14" {...props}>
    <path
      stroke="none"
      fillRule="eventodd"
      d="M95.357,72.571A3.128,3.128,0,0,0,97.4,69.608a3.215,3.215,0,0,0-1.435-2.8A5.54,5.54,0,0,0,92.91,66H86v2.356h1.211v9.287H86V80h6.487a7.343,7.343,0,0,0,3.764-.9A3.591,3.591,0,0,0,98,75.855,3.262,3.262,0,0,0,95.357,72.571Zm-3.206-1.026h-2.08V68.356h1.863c1.852,0,2.61.44,2.61,1.517C94.544,71.255,93.244,71.545,92.151,71.545Zm-2.08,2.425h2.2c2.038,0,2.87.515,2.87,1.779s-1,1.895-2.968,1.895h-2.1V73.97Z"
      transform="translate(-86 -66)"
    />
  </svg>
);

export default BoldIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/bold-icon.js